export default {"src":"/_next/static/image/public/images/ic_pay_apple.f0e1464a647e214e6c80f59ab2286504.svg","height":18,"width":15};